import React from 'react';
import './loading.scss';

/**
 * Loading
 * @param {Boolean} isFullPage
 * @param {Boolean} loadMore
 * @param {Boolean} isLight      - to show white bars instead of default blue bars
 */

const Loading = props => {
    if (props.isFullPage) {
        return (
            <div className="full-page-loader-container" role="status" aria-live="polite">
                <div className="loader">Loading...</div>
            </div>
        );
    } else {
        return (
            <div
                data-testid="loading"
                role="status"
                aria-live="polite"
                className={`loader ${props.loadMore ? 'load-more' : ''}
            ${props.isLight ? 'light-loader' : ''}`}>
                Loading...
            </div>
        );
    }
}

export default Loading;
